/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */
export const NotificationCenterEventClass = {
    FAILED: "FAILED",
    WARNING: "WARNING",
    SUCCESS: "SUCCESS",
    NEUTRAL: "NEUTRAL",
};
export const NotificationCenterEventParameterType = {
    Integer: "Integer",
    Float: "Float",
    Boolean: "Boolean",
    String: "String",
    Datetime: "Datetime",
    Uuid: "Uuid",
};
import axios from "axios";
import qs from "qs";
export var ContentType;
(function (ContentType) {
    ContentType["Json"] = "application/json";
    ContentType["FormData"] = "multipart/form-data";
    ContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
    ContentType["Text"] = "text/plain";
})(ContentType || (ContentType = {}));
export class HttpClient {
    instance;
    securityData = null;
    securityWorker;
    secure;
    format;
    constructor({ securityWorker, secure, format, ...axiosConfig } = {}) {
        this.instance = axios.create({
            ...axiosConfig,
            baseURL: axiosConfig.baseURL || "",
            paramsSerializer: (params) => qs.stringify(params, { arrayFormat: "indices" }),
        });
        this.secure = secure;
        this.format = format;
        this.securityWorker = securityWorker;
    }
    setSecurityData = (data) => {
        this.securityData = data;
    };
    mergeRequestParams(params1, params2) {
        const method = params1.method || (params2 && params2.method);
        return {
            ...this.instance.defaults,
            ...params1,
            ...(params2 || {}),
            headers: {
                ...((method && this.instance.defaults.headers[method.toLowerCase()]) || {}),
                ...(params1.headers || {}),
                ...((params2 && params2.headers) || {}),
            },
        };
    }
    stringifyFormItem(formItem) {
        if (typeof formItem === "object" && formItem !== null) {
            return JSON.stringify(formItem);
        }
        else {
            return `${formItem}`;
        }
    }
    createFormData(input) {
        return Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key];
            const propertyContent = property instanceof Array ? property : [property];
            for (const formItem of propertyContent) {
                const isFileType = formItem instanceof Blob || formItem instanceof File;
                formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
            }
            return formData;
        }, new FormData());
    }
    request = async ({ secure, path, type, query, format, body, ...params }) => {
        const secureParams = ((typeof secure === "boolean" ? secure : this.secure) &&
            this.securityWorker &&
            (await this.securityWorker(this.securityData))) ||
            {};
        const requestParams = this.mergeRequestParams(params, secureParams);
        const responseFormat = format || this.format || undefined;
        if (type === ContentType.FormData && body && body !== null && typeof body === "object") {
            body = this.createFormData(body);
        }
        if (type === ContentType.UrlEncoded && body && body !== null && typeof body === "object") {
            body = qs.stringify(body);
        }
        if (type === ContentType.Text && body && body !== null && typeof body !== "string") {
            body = JSON.stringify(body);
        }
        return this.instance.request({
            ...requestParams,
            headers: {
                ...(requestParams.headers || {}),
                ...(type && type !== ContentType.FormData ? { "Content-Type": type } : {}),
            },
            params: query,
            responseType: responseFormat,
            data: body,
            url: path,
        });
    };
}
/**
 * @title RVAI Notification Center Service
 * @version 0.1.0
 */
export class Api extends HttpClient {
    eventTypes = {
        /**
         * @description **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags event_types
         * @name ListEventTypes
         * @summary List Event Types
         * @request GET:/event-types
         * @secure
         */
        listEventTypes: (query, params = {}) => this.request({
            path: `/event-types`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_UPLOAD * INFERENCE * MODEL_CREATION * PROJECT_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags event_types
         * @name RegisterEventType
         * @summary Register Event Type
         * @request POST:/event-types
         * @secure
         */
        registerEventType: (data, params = {}) => this.request({
            path: `/event-types`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags event_types
         * @name ListEventTypeFields
         * @summary List Event Type Fields
         * @request GET:/event-types/fields
         * @secure
         */
        listEventTypeFields: (params = {}) => this.request({
            path: `/event-types/fields`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_UPLOAD * INFERENCE * MODEL_CREATION * PROJECT_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags event_types
         * @name DeregisterEventType
         * @summary Deregister Event Type
         * @request DELETE:/event-types/{event_type_id}/{event_type_version}
         * @secure
         */
        deregisterEventType: (eventTypeId, eventTypeVersion, params = {}) => this.request({
            path: `/event-types/${eventTypeId}/${eventTypeVersion}`,
            method: "DELETE",
            secure: true,
            ...params,
        }),
    };
    events = {
        /**
         * @description **Accepted permissions:** * DATA_UPLOAD * INFERENCE * MODEL_CREATION * PROJECT_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags events
         * @name TriggerEvent
         * @summary Trigger Event
         * @request POST:/events
         * @secure
         */
        triggerEvent: (data, params = {}) => this.request({
            path: `/events`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        }),
    };
    livez = {
        /**
         * @description Get application heartbeat.
         *
         * @tags monitor
         * @name GetHeartbeat
         * @summary Get Heartbeat
         * @request GET:/livez
         * @secure
         */
        getHeartbeat: (params = {}) => this.request({
            path: `/livez`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
    };
    notifications = {
        /**
         * @description **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags notifications
         * @name DeleteNotifications
         * @summary Delete Notifications
         * @request DELETE:/notifications
         * @secure
         */
        deleteNotifications: (query, params = {}) => this.request({
            path: `/notifications`,
            method: "DELETE",
            query: query,
            secure: true,
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags notifications
         * @name ListNotifications
         * @summary List Notifications
         * @request GET:/notifications
         * @secure
         */
        listNotifications: (query, params = {}) => this.request({
            path: `/notifications`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags notifications
         * @name DeleteAllNotifications
         * @summary Delete All Notifications
         * @request DELETE:/notifications/all
         * @secure
         */
        deleteAllNotifications: (params = {}) => this.request({
            path: `/notifications/all`,
            method: "DELETE",
            secure: true,
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags notifications
         * @name MarkAllNotificationsAsRead
         * @summary Mark All Notifications As Read
         * @request POST:/notifications/all/read
         * @secure
         */
        markAllNotificationsAsRead: (params = {}) => this.request({
            path: `/notifications/all/read`,
            method: "POST",
            secure: true,
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags notifications
         * @name ListNotificationFields
         * @summary List Notification Fields
         * @request GET:/notifications/fields
         * @secure
         */
        listNotificationFields: (params = {}) => this.request({
            path: `/notifications/fields`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags notifications
         * @name MarkNotificationsAsRead
         * @summary Mark Notifications As Read
         * @request POST:/notifications/read
         * @secure
         */
        markNotificationsAsRead: (query, params = {}) => this.request({
            path: `/notifications/read`,
            method: "POST",
            query: query,
            secure: true,
            ...params,
        }),
        /**
         * @description **Accepted permissions:** * DATA_LABELING * DATA_UPLOAD * INFERENCE * LABELING_REVIEW * MODEL_CREATION * PROJECT_CREATION * SYSTEM_MANAGEMENT
         *
         * @tags notifications
         * @name GetNotificationUpdates
         * @summary Get Notification Updates
         * @request GET:/notifications/updates
         * @secure
         */
        getNotificationUpdates: (params = {}) => this.request({
            path: `/notifications/updates`,
            method: "GET",
            secure: true,
            ...params,
        }),
    };
    prometheus = {
        /**
         * No description
         *
         * @tags monitor
         * @name GetPrometheusMetrics
         * @summary Get Prometheus Metrics
         * @request GET:/prometheus
         * @secure
         */
        getPrometheusMetrics: (params = {}) => this.request({
            path: `/prometheus`,
            method: "GET",
            secure: true,
            ...params,
        }),
    };
    version = {
        /**
         * @description Get application version.
         *
         * @tags monitor
         * @name GetVersion
         * @summary Get Version
         * @request GET:/version
         * @secure
         */
        getVersion: (params = {}) => this.request({
            path: `/version`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
    };
}
//# sourceMappingURL=data:application/json;base64,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